import React, { useState } from 'react';
import { useDialogKeyboard } from '../../../hooks/useDialogKeyboard';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  ModalDialog,
  Stack,
  Typography,
} from '@mui/joy';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const DeleteConfirmModal = ({ open, onClose, onConfirm, itemName }) => {
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    setDeleting(true);
    try {
      await onConfirm();
    } finally {
      setDeleting(false);
    }
  };

  useDialogKeyboard(open, { onEnter: handleConfirm, onEscape: onClose, disabled: deleting });

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog variant="outlined" role="alertdialog" sx={{ minWidth: 400 }}>
        <DialogTitle>
          <Stack direction="row" alignItems="center" gap={1}>
            <WarningAmberIcon color="warning" />
            Confirm Delete
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Typography level="body-md">
            Are you sure you want to delete{' '}
            <Typography component="span" fontWeight="lg">
              {itemName || 'this item'}
            </Typography>
            ?
          </Typography>
          <Typography level="body-sm" color="neutral" sx={{ mt: 1 }}>
            This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button color="danger" onClick={handleConfirm} loading={deleting}>
            Delete
          </Button>
          <Button variant="plain" color="neutral" onClick={onClose} disabled={deleting}>
            Cancel
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
};

export default DeleteConfirmModal;
